export const environment = {
    production: false,
    apiUrl: 'https://api-orion-dev.gohy.be/api',
    googleMapsApiKey: null,
};
